<template lang="pug">
    .km(v-if="!loader")
        .col
            label Atendimento
            select(v-model="form.id_atendimento")
                option(value="") Selecione
                option(v-for="at in atendimentos" :value="at.id") {{ at.id }} - Supporter {{ at.nome_doutor }} - {{ at.dh_checkin | date }}
        template(v-if="form.id_atendimento")
            .mt.col
                label Histórico
                input(v-model="form.historico" placeholder="Informe o motivo deste lançamento")
            .mt.col.text-red(v-if="limite>0" style="font-size: 18px;margin-top: 30px") O Limite para esse Job são de {{limite}} KM. 
            .row.js.mt.col-s.ac
                .g2.g12-s.col
                    label KM Adicional
                    input(v-model="form.km_total" @input="valor_doutor = modal.job.tipo_deslocamento == 'variavel' ? parseFloat(modal.job.valor_deslocamento).toFixed(2) * form.km_total : modal.job.valor_deslocamento" type="number" min="0" :max="limite" placeholder="KM"  @change="calcula_valor_km_doutor_cliente")
                .g2.g12-s.col(v-if="modal.job.tipo_deslocamento && modal.job.tipo_deslocamento.length")
                    label Tipo Desloc.
                    .valor(v-if="modal.job.tipo_deslocamento=='variavel'") Variável 
                    .valor(v-if="modal.job.tipo_deslocamento=='fixo'") Fixo
                .g2.g12-s.col(v-if="modal.job.tipo_deslocamento && modal.job.tipo_deslocamento.length")
                    label Valor Desloc. (R$)
                    .valor() {{ modal.job.valor_deslocamento | money }}
                .g2.g12-s.col
                    label Supporter (R$)
                    .valor {{ valor_doutor | money }}
                .g2.g12-s.col
                    label Cliente (R$)
                    .valor {{ form.valor_cliente | money }}
            .g10(v-if="form.valor_cliente>0") 
                label Destinatário
                input(v-model="form.destinatario" type="text"  placeholder="Destinatário")
            .g11(v-if="form.valor_cliente>0")
                label Mensagem
                textarea(v-model="form.mensagem" placeholder="Mensagem")
        Button(v-if="form.id_atendimento" layout="green-go" @click="add" :loader="btloader") 
            i.fa.fa-road 
            | LANÇAR   
    .loader-container.col.ac.jc(v-else)
        Loader
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";
import Loader from "@/components/Loader";
import { Money } from "v-money";
export default {
    name: "Km",
    props: { modal: Object },
    components: { Button, Loader, Money },
    data() {
        return {
            atendimentos: [],
            limite: 0,
            loader: true,
            btloader: false,
            valor_cliente: 0, valor_doutor: 0,
            form: { historico: "", valor_deslocamento: "", id_atendimento: "", km_total: 0, destinatario: null, mensagem: null },
            money: {
                decimal: ",",
                thousands: ".",
                precision: 2,
                masked: false,
            },
        };
    },
    methods: {
        ...mapActions("job", ["LOAD_ATTENDANCE"]),
        ...mapActions("admin", ["ADD_KM", "LIMIT_KM"]),
        calcula_valor_km_doutor_cliente() {
            if (this.modal.job.capital_interior == 'capital') {
                this.form.valor_doutor = ((this.form.km_total - this.user.config.franquia_km_dr_capital) * this.user.config.valor_km_dr).toFixed(2)
                this.form.valor_cliente = ((this.form.km_total - this.modal.job.franquia_deslocamento) * this.modal.job.valor_fat_km_adicional).toFixed(2)
            }
            else {
                this.form.valor_doutor = ((this.form.km_total - this.user.config.franquia_km_dr_interior) * this.user.config.valor_km_dr).toFixed(2)
                this.form.valor_cliente = ((this.form.km_total - this.modal.job.franquia_deslocamento) * this.modal.job.valor_fat_km_adicional).toFixed(2)
            }
            if (this.form.valor_cliente < 0) {
                alert("O valor do cliente deu menor que zero. Este valor será subistituido por zero.")
                this.form.valor_cliente = 0.00
            }

            if (this.form.valor_doutor < 0) {
                alert("O valor do supporter deu menor que zero. Isso indica que o KM informado está errado. O valor será subistituido por zero.")
                this.form.valor_doutor = 0.00
            }
        },
        async add() {
            this.btloader = true;
            this.form.job = this.modal.job.id
            this.calcula_valor_km_doutor_cliente()
            await this.ADD_KM(this.form)
            this.modal.close()
            this.btloader = false;
        },
        load_atendimentos() {
            this.LOAD_ATTENDANCE(this.modal.job.id).then(r => {
                this.atendimentos = r;
                this.loader = false;
            }).catch(() => this.loader = false);
        }
    },
    beforeMount() {
        this.load_atendimentos()
        this.LIMIT_KM(this.modal.job.id).then(r => r.limite && r.limite > 0 ? this.limite = r.limite : false)
    },
    computed: {
        ...mapGetters("user", ["user"]),
    },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *  
.km
    padding: 30px
    min-width: 900px
    @include label
    .valor
        color: $font-color
        padding: 4px
        margin-top: 4px
        font-size: 22px
    button
        margin-top: 20px
    @media (max-width: $small)
        select, input
            width: 30%
        label
            margin-top: 12px
.loader-container
    margin-top: 40px
    padding: 30px
</style>